<template>
  <div class="approval-page">
    <search-bar
      @search="onSearch"
      name="process_instance.rule_name,process_instance_item.handler_name,process_instance.creator_name,process_instance.biz_code,process_instance.extra_info"
      placeholder="输入流程名称、人员、单据编号进行查找"
      ref="searchBar"
    />
    <div class="weui-tab">
      <div class="weui-navbar">
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='approval'}"
          @click="activeTab='approval'"
        >
          待处理
          <span v-if="snapshot.approval.total">· {{snapshot.approval.total}}</span>
        </div>
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='notify'}"
          @click="activeTab='notify'"
        >
          知会
          <span v-if="snapshot.notify.total">· {{snapshot.notify.total}}</span>
        </div>
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='launched'}"
          @click="activeTab='launched'"
        >
          我的发起
          <span v-if="snapshot.launched.total">· {{snapshot.launched.total}}</span>
        </div>
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='childrenApproval'}"
          @click="activeTab='childrenApproval'"
        >
          集团审批
          <span v-if="snapshot.childrenApproval.total">· {{snapshot.childrenApproval.total}}</span>
        </div>
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='childrenNotify'}"
          @click="activeTab='childrenNotify'"
        >
          集团知会
          <span v-if="snapshot.childrenNotify.total">· {{snapshot.childrenNotify.total}}</span>
        </div>
        <div
          class="weui-navbar__item"
          :class="{'weui-bar__item_on': activeTab=='all'}"
          @click="activeTab='all'"
        >全部</div>
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='approval'">
        <instance-list :items="snapshot.approval.list" :on-search="onSearch" />
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='notify'">
        <instance-list :items="snapshot.notify.list" :on-search="onSearch" />
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='launched'">
        <instance-list :items="snapshot.launched.list" :on-search="onSearch" />
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='childrenApproval'">
        <instance-list :items="snapshot.childrenApproval.list" :on-search="onSearch" />
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='childrenNotify'">
        <instance-list :items="snapshot.childrenNotify.list" :on-search="onSearch" />
      </div>
      <div class="weui-tab__panel" v-if="activeTab=='all'">
        <instance-list :items="all.list" :on-search="onSearch" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import InstanceList from "@/views/process/InstanceList.vue";

export default {
  components: {
    SearchBar,
    InstanceList
  },
  data() {
    return {
      activeTab: "approval",
      params: {
        number: 1,
        size: 10
      },
      snapshot: {
        approval: {},
        notify: {},
        launched: {},
        childrenApproval: {},
        childrenNotify: {}
      },
      all: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.onSearch();
    });
  },
  methods: {
    onSearch(callback, next) {
      var me = this, callbackFn = typeof callback === 'function' ? callback : null;
      if (me.activeTab == "all") {
        me.loadAll(callbackFn, next);
      } else {
        me.loadSnapshot(callbackFn);
      }
    },
    /**
     * 待处理、知会、我的发起
     */
    loadSnapshot(callback) {
      var me = this,
        searchBar = this.$refs.searchBar,
        searchCondition = searchBar.getCondition(),
        condition = [];
      if (searchCondition) {
        condition.push(searchCondition);
      }
      me.$loading({
        url: "/api/process/instance/my_snapshot",
        params: Object.assign(
          {
            condition: JSON.stringify(condition)
          },
          me.params
        )
      }).then(function(res) {
        callback && callback.call(me);
        if (res.success) {
          me.snapshot = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    /**
     * 全部
     * @param {*} next 是否下一页
     */
    loadAll(callback, next) {
      var me = this,
        searchBar = this.$refs.searchBar,
        searchCondition = searchBar.getCondition(),
        condition = [],
        params;
      if (searchCondition) {
        condition.push(searchCondition);
      }
      params = Object.assign(
        {
          mode: 'MAIN',
          condition: JSON.stringify(condition)
        },
        me.params
      );
      params.number =
        next && me.all.list && me.all.list.length ? params.number + 1 : 1;
      if (me.activeTab == "all") {
        me.$loading({
          url: "/api/process/instance/my_list",
          params
        }).then(function(res) {
          callback && callback.call(me);
          if (res.success) {
            var data = res.data;
            if (next) {
              if (data.list && data.list.length) {
                me.params.number = params.number;
                me.all.list = me.all.list.concat(data.list);
              }
            } else {
              me.params.number = 1;
              me.all = data;
            }
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
      }
    }
  },
  watch: {
    activeTab(val) {
      if (val == "all") {
        this.loadAll();
      }
    }
  }
};
</script>

<style>
.approval-page .weui-search-bar__label span {
  font-size: 12px;
}
.approval-page .weui-navbar {
  /* background: #fff; */
  background-color: var(--weui-BG-2);
  justify-content: space-around;
}
.approval-page .weui-navbar__item.weui-bar__item_on {
  /* background: #fff; */
  background-color: var(--weui-BG-2);
  color: #07c160;
  border-color: #07c160;
}
.approval-page .weui-navbar__item {
  border-bottom: 2px solid transparent;
  padding: 5px 0;
  color: var(--weui-FG-0);
  font-size: 12px;
  flex: auto;
}
@media screen and (max-width: 360px) {
  .approval-page .weui-navbar__item {
    scale: 0.8;
  }
}
.approval-page .weui-navbar:after,
.approval-page .weui-navbar__item:after {
  content: none;
}
.approval-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 62px;
  display: flex;
  flex-direction: column;
}
.approval-page .weui-tab {
  flex: 1;
  overflow: hidden;
}
.approval-page .weui-tab__panel {
  display: flex;
  flex-direction: column;
}
</style>